import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import {ActionButton,ToggleSwitch} from "../../../helper/ImageFormat";
import { useEffect, useRef } from "react";
import dateformate from "../../../helper/DateFormate";
const ShippingPartnerTable = ({
    loading,
    shipping,
    currentPage,
    perPage,
    handleEditClick,
    handleDelete,
    handleStatusToggle,
    totalCount,
    totalPages,
    handlePageClick,
    selected,
    setSelected,
}) => {
    const selectAllRef = useRef(null);
    const isAllSelected =
        shipping.length > 0 && selected.length === shipping.length;
    const isIndeterminate =
        selected.length > 0 && selected.length < shipping.length;

    useEffect(() => {
        if (selectAllRef.current) {
            selectAllRef.current.indeterminate = isIndeterminate;
        }
    }, [isIndeterminate]);

    const toggleSelectAll = () => {
        setSelected(isAllSelected ? [] : shipping.map((b) => b.id));
    };

    const toggleSelectOne = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
        );
    };


    return (
        <div className="row ">
            <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table
                                className=" custom-table table table-striped"
                                id="myTable"
                                style={{ marginTop: "3px" }}
                            >
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                ref={selectAllRef}
                                                checked={isAllSelected}
                                                onChange={toggleSelectAll}
                                            />
                                        </th>
                                        <th>Name</th>
                                        <th>Is Active</th>
                                        <th>Updated At</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <Spinner />
                                            </td>
                                        </tr>
                                    ) : shipping.length > 0 ? (
                                        shipping.map((data, id) => (
                                            <tr key={data.id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selected.includes(data.id)}
                                                        onChange={() => toggleSelectOne(data.id)}
                                                    />
                                                </td>
                                                <td>{data?.name}</td>
                                                <td>{dateformate(data.updatedAt)}</td>
                                                {/* <td>{dateformate(data.createdAt)}</td> */}
                                                <td>
                                                    <ToggleSwitch
                                                        data={data}
                                                        name="isActive"
                                                        checked={data.isActive}
                                                        handleStatusToggle={handleStatusToggle}
                                                        module={"Shipping partner"}
                                                    />
                                                </td>
                                                <td>
                                                    <ActionButton
                                                        data={data}
                                                        handleEditClick={handleEditClick}
                                                        handleDelete={handleDelete}
                                                        module={"Shipping partner"}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <h4>No data available</h4>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {shipping?.length > 0 && (
                            <div>
                                <CustomPagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageClick}
                                    perPage={perPage}
                                    totalCount={totalCount}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShippingPartnerTable;
